import { ErrorState } from "@bafe/ui";
import { Component, type ErrorInfo, type ReactNode } from "react";

type Props = { children: ReactNode };

type State = { error: Error | null };

export class RootErrorBoundary extends Component<Props, State> {
	override state: State = { error: null };

	static getDerivedStateFromError(error: Error): State {
		return { error };
	}

	override componentDidCatch(error: Error, info: ErrorInfo) {
		console.error("Key control panel failed to render.", error, info.componentStack);
	}

	override render() {
		if (this.state.error) {
			return (
				<main className="flex min-h-screen items-center justify-center p-6">
					<div className="flex w-full max-w-md flex-col gap-3">
						<ErrorState
							title="This page could not load."
							description="Try again in a moment. If it keeps happening, sign in from a private window or contact support."
							onRetry={() => window.location.reload()}
						/>
						<p className="text-center text-sm">
							<a
								href="/signin"
								className="font-medium text-(--color-brand-700) underline underline-offset-2"
							>
								Go to sign in
							</a>
						</p>
					</div>
				</main>
			);
		}

		return this.props.children;
	}
}
